export default __webpack_public_path__ + "static/media/mobile_non_breed.43aaa0ff.jpg";